import * as actions_stock_parts from 'actions/stock-parts-actions'
import React from 'react'
import { CSVImportExport } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

const ImportParts = () => {

    const params = useParams();
	const TYPE = params.asset_type_id;
	const partsCategories = useSelector((store) => store.settings.settings_parts_categories);

    // OPTIONAL: _category, _primaryVendorId, and _secondaryVendorId

    const columns = [
        'assetTypeId*',
        'name*',
        'partNumber',
        'manufacturer',
        'description',
        'price',
        'unitId',
        'estimatedHours',
        'inventory',
        'minimumInventory',
        'imageUrl',
        'primaryVendorId',
        'secondaryVendorId',
    ];

    const handleImport = async (row) => {
        return actions_stock_parts.importStockPart(params.handle, row, partsCategories);
    };   
    const getExport = async () => {
        return actions_stock_parts.exportStockParts(params.handle, columns);
    };  
    
    return (
        <div className='col mt-3'>
            <CSVImportExport className="float-right" table={'stock-parts'} columns={columns} onImport={handleImport} getExport={getExport} />
        </div>
    )
}

export default ImportParts